import { render } from "./AppEmptyState.vue?vue&type=template&id=b8bc7fd4&scoped=true"
import script from "./AppEmptyState.vue?vue&type=script&lang=js"
export * from "./AppEmptyState.vue?vue&type=script&lang=js"

import "./AppEmptyState.vue?vue&type=style&index=0&id=b8bc7fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8bc7fd4"]])

export default __exports__